export const CELL_ATTRIBUTE = 'data-hs-cell-id';
export const ROW_ATTRIBUTE = 'data-hs-row-id';
export const ROW_TREE_ATTRIBUTE = 'data-hs-tree-id';
export const STATIC_SECTION_ATTRIBUTE = 'data-fixed-layout-section-id';
export const STATIC_SECTION_CLASS_NAME = 'fixed-layout-section';
export const EMBED_ATTRIBUTE = 'data-embed-row-id';
export const EMPTY_PLACEHOLDER_ID_PARTIAL = '__hs-ls-empty-placeholder';